import { z } from 'zod';

export const usersFiltersSchema = z.object({
  search: z.string().optional(),
  roleId: z.string().optional(),
});

export type UsersFilters = z.infer<typeof usersFiltersSchema>;
